"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWebhookRequestSchema = exports.CreateWebhookRequestSchema = exports.PostWebhookRequestSchema = void 0;
const zod_1 = require("zod");
const auth_1 = require("./auth");
exports.PostWebhookRequestSchema = zod_1.z.object({
    context: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
exports.CreateWebhookRequestSchema = zod_1.z.object({
    url: zod_1.z.string(),
    name: zod_1.z.string(),
    method: zod_1.z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
    auth: auth_1.OutboundWebhookAuthSchema,
    header_template: zod_1.z.string(),
    body_template: zod_1.z.string(),
});
exports.UpdateWebhookRequestSchema = zod_1.z.object({
    url: zod_1.z.optional(zod_1.z.string()),
    name: zod_1.z.optional(zod_1.z.string()),
    method: zod_1.z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
    auth: zod_1.z.optional(auth_1.OutboundWebhookAuthSchema),
    header_template: zod_1.z.optional(zod_1.z.string()),
    body_template: zod_1.z.optional(zod_1.z.string()),
});
